import React, { useContext } from 'react';
import { CartContext } from '../context/CartContext';

const ProductCard = ({ product, showDirectOption = false }) => {
  const { addToCart } = useContext(CartContext);

  const handleAddToCart = () => {
    addToCart(product);
    alert(`${product.name} added to cart!`);
  };

  return (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition duration-300 transform hover:-translate-y-1">
      {/* Product Image */}
      <div className="h-64 bg-gray-200 flex items-center justify-center">
        {product.image ? (
          <img 
            src={product.image} 
            alt={product.name} 
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="flex flex-col items-center justify-center text-gray-400">
            <svg 
              className="w-24 h-24 mb-2" 
              fill="currentColor" 
              viewBox="0 0 20 20"
            >
              <path 
                fillRule="evenodd" 
                d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z" 
                clipRule="evenodd" 
              />
            </svg>
            <span className="text-sm">Product Image</span>
          </div>
        )}
      </div>

      {/* Product Info */}
      <div className="p-6">
        <h3 className="text-xl font-bold text-forest-green mb-2">
          {product.name}
        </h3>
        <p className="text-gray-600 mb-4 line-clamp-2">
          {product.description}
        </p>
        <p className="text-2xl font-bold text-forest-green mb-4">
          ${product.price} CAD
        </p>

        {/* Social Share Buttons */}
        <div className="flex items-center gap-3 mb-4">
          {typeof window !== 'undefined' && (
            (() => {
              const productUrl = `${window.location.origin}/products/${product.id}`;
              const text = encodeURIComponent(`${product.name} - ${product.description}`);
              return (
                <>
                  <button
                    onClick={() => window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(productUrl)}`, '_blank')}
                    className="px-3 py-1 bg-blue-600 text-white rounded hover:opacity-90 text-xs"
                    aria-label="Share on Facebook"
                  >
                    FB
                  </button>

                  <button
                    onClick={() => window.open(`https://twitter.com/intent/tweet?text=${text}&url=${encodeURIComponent(productUrl)}`, '_blank')}
                    className="px-3 py-1 bg-sky-500 text-white rounded hover:opacity-90 text-xs"
                    aria-label="Share on X"
                  >
                    X
                  </button>

                  <button
                    onClick={() => window.open(`https://pinterest.com/pin/create/button/?url=${encodeURIComponent(productUrl)}&media=${encodeURIComponent(product.image || '')}&description=${text}`, '_blank')}
                    className="px-3 py-1 bg-red-600 text-white rounded hover:opacity-90 text-xs"
                    aria-label="Pin on Pinterest"
                  >
                    Pin
                  </button>

                  <button
                    onClick={async () => {
                      try {
                        await navigator.clipboard.writeText(productUrl);
                        alert('Product link copied to clipboard');
                      } catch (e) {
                        window.prompt('Copy the link:', productUrl);
                      }
                    }}
                    className="px-3 py-1 bg-gray-200 text-forest-green rounded hover:opacity-90 text-xs"
                    aria-label="Copy product link"
                  >
                    Link
                  </button>
                </>
              );
            })()
          )}
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col gap-2">
          {/* Direct Purchase Button */}
          {showDirectOption && (
            <button
              onClick={handleAddToCart}
              className="w-full bg-amber-600 text-white px-4 py-2 rounded-lg hover:bg-amber-700 transition duration-300 font-semibold"
            >
              🛒 Buy Directly
            </button>
          )}

          {/* Marketplace Links */}
          <div className="flex gap-2">
            <a
              href={product.amazonLink || '#'}
              target="_blank"
              rel="noopener noreferrer"
              className={`flex-1 bg-forest-green text-white px-4 py-2 rounded-lg hover:bg-opacity-90 transition duration-300 text-center font-semibold ${
                showDirectOption ? 'text-sm' : ''
              }`}
            >
              Amazon
            </a>
            <a
              href={product.walmartLink || '#'}
              target="_blank"
              rel="noopener noreferrer"
              className={`flex-1 bg-moss-green text-white px-4 py-2 rounded-lg hover:bg-opacity-90 transition duration-300 text-center font-semibold ${
                showDirectOption ? 'text-sm' : ''
              }`}
            >
              Walmart
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
